import './terms-conditions.sass';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

function Terms() {
  const { t } = useTranslation();
  return (
    <Container fluid className="terms-container">
      <Terms_intro />
      <Terms_1 />
      <Terms_2 />
      <Terms_3 />
      <Terms_4 />
      <Terms_5 />
      <Terms_6 />
      <Terms_7 />
      <Terms_8 />
      <Terms_9 />
      <Terms_10 />
      <Terms_11 />
      <Terms_12 />
      <Terms_13 />
      <Terms_14 />
      <Terms_end />
    </Container>
  );
}

function Terms_intro() {
  return (
    <Row>
      <Col>
        <h1 className="terms-intro-title">
          <Trans i18nKey="termsAndConditions_title" />
        </h1>
        <div>
          <h4>
            <Trans i18nKey="termsAndConditions_intro_title" />
          </h4>
          <p>
            <Trans i18nKey="termsAndConditions_intro_paragraph" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_1() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="aboutTheAppTitle" />
          </h4>
          <p>
            <Trans i18nKey="aboutTheAppIntro" />
          </p>

          <p>
            <Trans i18nKey="appDefinition.title" />
            <br />
            <Trans i18nKey="appDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="termsAndConditionsDefinition.title" />
            <br />
            <Trans i18nKey="termsAndConditionsDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="personalDataDefinition.title" />
            <br />
            <Trans i18nKey="personalDataDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="serviceProviderDefinition.title" />
            <br />
            <Trans i18nKey="serviceProviderDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="provisionOfServicesDefinition.title" />
            <br />
            <Trans i18nKey="provisionOfServicesDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="userDefinition.title" />
            <br />
            <Trans i18nKey="userDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="contractDefinition.title" />
            <br />
            <Trans i18nKey="contractDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="contractDetails.termsAndConditions" />
          </p>

          <p>
            <Trans i18nKey="contractDetails.specialTerms" />
          </p>

          <p>
            <Trans i18nKey="contractDetails.additionalTerms" />
          </p>

          <p>
            <Trans i18nKey="priceDefinition.title" />
            <br />
            <Trans i18nKey="priceDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="intermediationFeesDefinition.title" />
            <br />
            <Trans i18nKey="intermediationFeesDefinition.description" />
          </p>

          <p>
            <Trans i18nKey="paymentsDefinition.title" />
            <br />
            <Trans i18nKey="paymentsDefinition.description" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_2() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="acceptanceAndConclusionTitle" />
          </h4>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item1" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item2" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item3" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item4" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item5" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item6" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item6_1" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item6_2" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item6_3" />
          </p>
          <p>
            <Trans i18nKey="acceptanceAndConclusion.item7" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_3() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="contractualRelationshipTitle" />
          </h4>
          <p>
            <Trans i18nKey="contractualRelationship.item1" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item2" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_1" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_2" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_3" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_4" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_5" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_6" />
          </p>
          <p>
            <Trans i18nKey="contractualRelationship.item3_7" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_4() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="priceTitle" />
          </h4>
          <p>
            <Trans i18nKey="price.item1" />
          </p>
          <p>
            <Trans i18nKey="price.item2" />
          </p>
          <p>
            <Trans i18nKey="price.item3" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_5() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="meansOfPaymentTitle" />
          </h4>
          <p>
            <Trans i18nKey="meansOfPayment.item1" />
          </p>

          <p>
            <Trans i18nKey="meansOfPayment.item2" />
          </p>

          <p>
            <Trans i18nKey="meansOfPayment.item3" />
          </p>

          <p>
            <Trans i18nKey="meansOfPayment.item4" />
          </p>

          <p>
            <Trans i18nKey="meansOfPayment.item5" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_6() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="userIdentificationTitle" />
          </h4>
          <p>
            <Trans i18nKey="userIdentification.item1" />
          </p>
          <p>
            <Trans i18nKey="userIdentification.item2" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_7() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="Responsibilitytitle" />
          </h4>
          <p>
            <Trans i18nKey="Responsibility.item1" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item2" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item3" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item3_1" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item3_2" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item3_3" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item4" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item5" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item6" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item7" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8_1" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8_2" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8_3" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8_4" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8_5" />
          </p>
          <p>
            <Trans i18nKey="Responsibility.item8_6" />
          </p>
        </div>

        <br></br>
      </Col>
    </Row>
  );
}

function Terms_8() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="Sanctions.title" />
          </h4>
          <p>
            <Trans i18nKey="Sanctions.description" />
          </p>
          <p>
            <Trans i18nKey="Sanctions.item1" />
          </p>
          <p>
            <Trans i18nKey="Sanctions.item2" />
          </p>
          <p>
            <Trans i18nKey="Sanctions.item3" />
          </p>
          <p>
            <Trans i18nKey="Sanctions.item4" />
          </p>
          <p>
            <Trans i18nKey="Sanctions.item5" />
          </p>
          <p>
            <Trans i18nKey="Sanctions.item6" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_9() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="IntellectualPropertyRightsTitle" />
          </h4>

          <p>
            <Trans i18nKey="IntellectualPropertyRights.item1" />
          </p>

          <p>
            <Trans i18nKey="IntellectualPropertyRights.item2" />
          </p>

          <p>
            <Trans i18nKey="IntellectualPropertyRights.item3" />
          </p>

          <p>
            <Trans i18nKey="IntellectualPropertyRights.item4" />
          </p>

          <p>
            <Trans i18nKey="IntellectualPropertyRights.item5" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_10() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="UserRatingsTitle" />
          </h4>
          <p>
            <Trans i18nKey="UserRatings.item1" />
          </p>
          <p>
            <Trans i18nKey="UserRatings.item2" />
          </p>
          <p>
            <Trans i18nKey="UserRatings.item3" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_11() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="TermAndTerminationTitle" />
          </h4>
          <p>
            <Trans i18nKey="TermAndTermination.item1" />
          </p>
          <p>
            <Trans i18nKey="TermAndTermination.item2" />
          </p>
          <p>
            <Trans i18nKey="TermAndTermination.item3" />
          </p>
          <p>
            <Trans i18nKey="TermAndTermination.item4" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_12() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="DisputeResolutionTitle" />
          </h4>
          <p>
            <Trans i18nKey="DisputeResolution.item1" />
          </p>
          <p>
            <Trans i18nKey="DisputeResolution.item2" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_13() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="FinalTransitionalProvisionsTitle" />
          </h4>
          <p>
            <Trans i18nKey="FinalTransitionalProvisions.item1" />
          </p>
          <p>
            <Trans i18nKey="FinalTransitionalProvisions.item2" />
          </p>
          <p>
            <Trans i18nKey="FinalTransitionalProvisions.item3" />
          </p>
          <p>
            <Trans i18nKey="FinalTransitionalProvisions.item4" />
          </p>
          <p>
            <Trans i18nKey="FinalTransitionalProvisions.item5" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_14() {
  return (
    <Row>
      <Col>
        <div>
          <h4>
            <Trans i18nKey="ApplicableLawAndJurisdictionTitle" />
          </h4>
          <p>
            <Trans i18nKey="ApplicableLawAndJurisdiction.item1" />
          </p>
          <p>
            <Trans i18nKey="ApplicableLawAndJurisdiction.item2" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

function Terms_end() {
  return (
    <Row>
      <Col>
        <div>
          <p>
            <Trans i18nKey="ItShouldBeAdded" />
          </p>
          <p>
            <Trans i18nKey="ServiceProviderWorkNonCompliance" />
          </p>
          <p>
            <Trans i18nKey="QualifiedServiceProviderSubstitution" />
          </p>
          <p>
            <Trans i18nKey="QualityStandardsSatisfaction" />
          </p>
          <p>
            <Trans i18nKey="AgreementAcknowledgment" />
          </p>
        </div>
        <br></br>
      </Col>
    </Row>
  );
}

export { Terms };
